'use client';

import { setCustomerReferralCodeToCookie } from '@/lib/actions/customer';
import { useEffect } from 'react';

type SetReferralClientProps = {
  referralCode: string;
};

export default function SetReferralClient({
  referralCode,
}: SetReferralClientProps) {
  useEffect(() => {
    const setReferalCode = async (code: string) => {
      await setCustomerReferralCodeToCookie(code);
    };
    if (referralCode) {
      setReferalCode(referralCode);
    }
  }, [referralCode]);

  return null;
}
